import { Avatar } from '@src/atoms/Avatar';
import { Box } from '@src/atoms/Box';
import { Icon } from '@src/atoms/Icon';
import { Text } from '@src/atoms/Text';
import React, { FC, useContext } from 'react';
import { format } from 'date-fns';
import { ru } from 'date-fns/locale';
import { BreakpointsContext } from '@centra/ui-global-context';
import { classnames } from '@src/utils/classnames';
import { IMessage } from '../models';
import { Link } from '@src/atoms/Link';
import styled from './ZoomMessageInfo.module.scss';

interface IZoomMessageInfoProps {
  message: IMessage;
  creationDate?: Date;
  fileHref?: string;
}

export const ZoomMessageInfo: FC<IZoomMessageInfoProps> = ({ message, creationDate, fileHref }) => {
  const { isMobile } = useContext(BreakpointsContext);

  const downLoadClasses = classnames(
    styled.downloadIconContainer,
    isMobile ? styled.downloadIconContainerMobile : styled.downloadIconContainerDesktop,
  );

  return (
    <Box className={styled.root} fullWidth={!isMobile} justifyContent={{ MOBILE: 'spaceBetween' }}>
      <Box className={styled.messageInfo} gap={8} alignItems={'center'} padding={8}>
        <Avatar
          imageUrl={message.sender.avatar}
          firstName={message.sender.firstName}
          lastName={message.sender.lastName}
          size="sm"
          grayscale
          storage={'account-avatar'}
        />
        <Box column fullWidth>
          <Text id="senderName" color={'basicWhite'} size={'secondary'} weight={'bold'}>
            {message?.sender?.firstName} {message?.sender?.lastName}
          </Text>
          {creationDate && (
            <Text id="creationDate" color={'basicGrey'} size={'secondary'}>
              {format(creationDate, 'd MMMM', { locale: ru })} в {format(creationDate, 'H:mm', { locale: ru })}
            </Text>
          )}
        </Box>
      </Box>

      {fileHref && (
        <Box className={downLoadClasses} padding={12}>
          <Link id="fileLink" href={fileHref} target="_blank" noStyles>
            <Icon name={'download'} view={'basicWhite'} size={'md'} />
          </Link>
        </Box>
      )}
    </Box>
  );
};
